import { COLORS } from 'consts/colors'
import { FLYOUT_Z_INDEX } from 'consts/zIndex'

import { boxShadowStyles } from 'styles/mixins'
import styled from 'styled-components'

interface IColorPickerWrapperProps {
  left: number
  top: number
  $borderRadius: number
}

const COLOR_PICKER_WIDTH = 238

export const ColorPickerWrapper = styled.div<IColorPickerWrapperProps>`
  position: absolute;
  top: ${props => props.top}px;
  left: ${props => props.left}px;
  width: ${COLOR_PICKER_WIDTH}px;
  border: 1px solid ${COLORS.border};
  border-radius: ${({ $borderRadius }) => $borderRadius}px;

  & > div {
    border-radius: ${({ $borderRadius }) => $borderRadius}px;
  }
  ${boxShadowStyles('shadow2')}
  z-index: ${FLYOUT_Z_INDEX + 1};
`
